import { render } from "./VariableBlockComponent.vue?vue&type=template&id=1ad02c6a&scoped=true"
import script from "./VariableBlockComponent.vue?vue&type=script&lang=js"
export * from "./VariableBlockComponent.vue?vue&type=script&lang=js"

import "./VariableBlockComponent.vue?vue&type=style&index=0&id=1ad02c6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ad02c6a"

export default script